import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTitleConfig {
  [key: string]: {
    title: string;
    description: string;
  };
}

const pageConfig: PageTitleConfig = {
  '/': {
    title: 'Product Designer | Christopher Samuels',
    description: 'Product Designer | Christopher Samuels'
  },
  '/about': {
    title: 'About | Christopher Samuels',
    description: 'Learn more about Christopher Samuels, Product Designer'
  },
  '/tuney': {
    title: 'Tuney | Christopher Samuels',
    description: 'Tuney case study - AI-powered music creation platform reimagining how artists make music'
  },
  '/bace': {
    title: 'Bace | Christopher Samuels',
    description: 'Voice-to-MIDI software case study - Patent awarded technology with 95% accuracy'
  },
  '/cbyon': {
    title: 'CBYON | Christopher Samuels',
    description: 'CBYON case study - Innovative design solutions and user experience'
  },
  '/brewerydb': {
    title: 'BreweryDB | Christopher Samuels',
    description: 'BreweryDB case study - Craft beer database and API design'
  },
  '/brewlogix': {
    title: 'BrewLogix | Christopher Samuels',
    description: 'BrewLogix case study - Brewery management and analytics platform'
  },
  '/t-mobile-5gin': {
    title: 'T-Mobile 5Gin | Christopher Samuels',
    description: 'T-Mobile 5Gin case study - 5G network experience design'
  },
  '/music': {
    title: 'After Selection | Chris Samuels',
    description: 'Industrial / EBM solo project from Chris Samuels — After Selection EP'
  },
  '/music/links': {
    title: 'After Selection | Chris Samuels',
    description: 'Listen on your preferred music platform'
  }
};

export const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const config = pageConfig[location.pathname] || {
      title: 'Christopher Samuels',
      description: 'Product Designer | Christopher Samuels'
    };

    // Update document title
    document.title = config.title;

    // Update meta tags
    const updateMetaTag = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    updateMetaTag('og:title', config.title);
    updateMetaTag('og:description', config.description);
  }, [location.pathname]);
};
